import styled from 'styled-components'

export const BackdoorSettingsContainer = styled.div`
  z-index: 99999;
  position: fixed;
  bottom: 24px;
  right: 24px;
`
